export default "__VITE_PUBLIC_ASSET__22c754c2__"